import {
  Box,
  List,
  ListItem,
  ListItemText,
  TextFieldProps,
} from '@material-ui/core';
import React, { FC, useContext, useEffect, useState } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  Suggestion,
} from 'react-places-autocomplete';
import { DestinationContext } from '../../../Providers/Destination';
import { ExpediteurContext } from '../../../Providers/Expediteur';
import { ExpediteurLocationContext } from '../../../Providers/ExpediteurLocation';
import { IndexDeliveryContext } from '../../../Providers/IndexDelivery';
import TextInput from '../../TextInput';
import styles from '../style';

const SearchInMap: FC<TextFieldProps> = (props) => {
  const classes = styles();
  const [address, setAddress] = useState('');

  const {
    setLatitudeExpediteurLocation,
    setLongitudeExpediteurLocation,
    latitude,
    longitude,
  } = useContext(ExpediteurLocationContext);

  const {
    setLatitudeDestination,
    setLongitudeDestination,
    latitude: latitudeDest,
    longitude: longitudeDest,
    address: addressDestination,
  } = useContext(DestinationContext);

  const { indexDelivery } = useContext(IndexDeliveryContext);

  const { setIdExpediteur, setAdressExpediteur, address: addressExpediteur } = useContext(ExpediteurContext);
  const { setIdDestination, setAdressDestination } = useContext(DestinationContext);

  useEffect(() => {
    if (indexDelivery === 0 && addressExpediteur) {
      setAddress(addressExpediteur);
    }
  }, [addressExpediteur, indexDelivery]);

  useEffect(() => {
    if (indexDelivery === 1 && addressDestination) {
      setAddress(addressDestination);
    }
  }, [addressDestination, indexDelivery]);

  const searchOptions = {
    componentRestrictions: { country: ['mg'] },
  };

  const handleChange = (addressIn: string) => {
    setAddress(addressIn);
  };

  const handleSelect = async (addressIn: string, placeID: string) => {
    try {
      setAddress(addressIn);
      const result = await geocodeByAddress(addressIn);
      const { lat, lng } = await getLatLng(result[0]);

      if (indexDelivery === 0) {
        if (lat !== latitude && lng !== longitude) {
          setIdExpediteur('');
        }
        setLatitudeExpediteurLocation(lat);
        setLongitudeExpediteurLocation(lng);
        setAdressExpediteur(addressIn);
      }

      if (indexDelivery === 1) {
        if (lat !== latitudeDest && lng !== longitudeDest) {
          setIdDestination('');
        }
        setLatitudeDestination(lat);
        setLongitudeDestination(lng);
        setAdressDestination(addressIn);
      }
    } catch (err) {
      console.log('error', err);
    }
  };

  return (
    <Box className={classes.root}>
      <PlacesAutocomplete
        debounce={1500}
        value={address}
        searchOptions={searchOptions}
        onChange={(value) => handleChange(value)}
        onSelect={(address, placeId) => handleSelect(address, placeId)}>
        {({ getInputProps, suggestions, getSuggestionItemProps }) => {
          return (
            <>
              <TextInput
                {...(getInputProps({
                  placeholder: 'Rechercher un lieu',
                }) as any)}
                variant="filled"
              />
              {suggestions.length > 0 && (
                <List className={classes.list}>
                  {suggestions.map((suggestion: Suggestion, index: number) => {
                    return (
                      <ListItem
                        key={`list${index}`}
                        {...getSuggestionItemProps(suggestion)}
                        button
                        dense
                        divider>
                        <ListItemText
                          primary={suggestion.formattedSuggestion.mainText}
                          secondary={
                            suggestion.formattedSuggestion.secondaryText
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </>
          );
        }}
      </PlacesAutocomplete>
    </Box>
  );
};

export default SearchInMap;
